var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-wrapper"},[_c('swiper-wrapper'),_c('banner'),_c('jinr-important'),_c('mid-tab'),_c('news'),_c('partner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }